<script setup lang="ts">
import { NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuRoot, NavigationMenuSub, NavigationMenuTrigger } from "reka-ui";

const { siteOptions } = useSiteOptions();
</script>

<template>
  <NavigationMenuRoot v-if="siteOptions" id="menu-mobile">
    <NavigationMenuList class="text-lg font-medium">
      <!-- Main menu -->
      <NavigationMenuItem v-for="item in [...siteOptions.main_menu_items, ...siteOptions.top_menu_items]" :key="item.id" class="" :class="item.class">
        <template v-if="item.children.length > 0">
          <NavigationMenuTrigger class="group flex w-full items-center justify-between gap-3 py-3 data-[state=closed]:border-b">
            {{ item.title }}
            <span class="i-lucide-chevron-down size-6 text-orange transition-transform ease-in group-data-[state=open]:-rotate-180" />
          </NavigationMenuTrigger>
          <NavigationMenuContent class="not-dark color-white bg-mascot-bottom -mx-6 px-6 pt-1.5">
            <NavigationMenuSub>
              <NavigationMenuList v-for="column in item.children" :key="column.id">
                <NavigationMenuItem v-for="child in column.children" :key="child.id" :class="child.class">
                  <NavigationMenuLink :href="child.url" :target="child.target" class="flex py-1.5">
                    {{ child.title }}
                  </NavigationMenuLink>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenuSub>
          </NavigationMenuContent>
        </template>
        <NavigationMenuLink v-else :href="item.url" class="flex py-3">
          {{ item.title }}
        </NavigationMenuLink>
      </NavigationMenuItem>
    </NavigationMenuList>
    <!-- Social medias -->
    <UiSocialMedias :items="siteOptions.contact.social_medias" class="py-3" />
  </NavigationMenuRoot>
</template>
